export const globalMixin = {
    methods: {
        $getConfigText(key) {
            if(!key) return ''
            const isExist = this.$te(`paas_home.${key}`)
            if(!isExist){
                return ''
            }else{
                return this.$t(`paas_home.${key}`)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/globalMixin.js